<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <v-card class="text-center pa-4">
      <v-card-title class="justify-center">
        <div class="d-flex flex-column align-center w-100">
          <img
            :src="require('@/assets/logoifdc3.png')"
            height="60"
            width="60"
            class="mb-2"
          />
          <div>U.N.E.S. San Antonio Oeste</div>
        </div>
      </v-card-title>

      <v-card-text>
        <div v-if="cargando">
          <v-progress-circular
            indeterminate
            color="primary"
            size="48"
            class="my-4"
          ></v-progress-circular>
          <p class="subtitle-1">Validando tu acceso e inscribiéndote…</p>
        </div>

        <div v-else-if="error">
          <v-alert type="error" outlined>{{ error }}</v-alert>
          <v-btn color="primary" @click="$router.push({ name: 'login' })">
            Ir al inicio
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import authService from "@/services/auth.service";

export default {
  name: "AccesoDirecto",
  data() {
    return {
      dialog: true,
      cargando: true,
      error: "",
    };
  },
  async created() {
    const token = this.$route.query.token;
    if (!token) {
      this.cargando = false;
      this.error = "El enlace no es válido.";
      return;
    }
    const { success, errors } = await authService.accesoDirecto(token);
    if (success) {
      // Redirección dura: arranca la app de cero con el token ya guardado y
      // saca el token de la URL (evita re-ejecutar este componente en loop).
      window.location.href = "/alumno/inscribir-carrera";
    } else {
      this.cargando = false;
      this.error =
        errors ||
        "El enlace no es válido o expiró. Solicitá uno nuevo desde el registro.";
    }
  },
};
</script>

<style scoped></style>
